import { z } from "zod"
import { Network, Token } from "@/config/tokens"

export const formSchema = z.object({
  amount: z
    .string({ description: "Amount must be greater than zero" })
    .regex(
      /^$|^[0-9]+(\.[0-9]{1,6})?$/,
      "Amount must be a valid value with up to 6 decimal places",
    )
    .optional(),
  network: z.nativeEnum(Network),
  token: z.nativeEnum(Token),
})
